// HOC shared by registration and account manager
import { withAccountOverview } from 'components/account'

// presentational component specific to registration
import UI from './UI'

export default withAccountOverview(UI)
